var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dashboard-container"},[_c('b-container',{staticClass:"form-style"},[_c('br'),_c('h2',[_vm._v("Nou servei:")]),_c('hr'),_c('qemu-form')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }